const CheckIcon = () => {
    return(
        <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M3.54199 9.91669L6.02116 12.3959L13.4587 4.60419" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
    )
}

export default CheckIcon